import * as types from "./dashboardActionTypes";
import fetchUrl from "../../services/fetchUrl";
import {
  showSnackBar,
  showSuccessSnackBar
} from "../../components/Snackbar/snackbarActions";
import { logEvents } from "../../redux/commonActions";
import makeAjaxRequest from "../../services/makeAjaxRequest";
import { getErrorMessage } from "../../services/utils";
import { postJobSuccess } from "../JobPosting/jobPostingActions";
import CacheService from "../../services/CacheService";
import { STORAGE_ITEMS, STORAGE_KEYS } from "../../services/constants";

/* Get dashboard info  */

export const getDashboard = ({
  tabId = "",
  pageNo = 1,
  size = 10,
  showLoading = true
}) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      if (pageNo == 1 && showLoading) dispatch(getDashboardLoading());
      makeAjaxRequest({
        method: "GET",
        url: fetchUrl("recruiter", "job/v4/dashboard"),
        auth: true,
        queryParams: {
          tab: tabId,
          page_number: pageNo,
          size: size
        }
      })
        .then(response => {
          let data = response.data.data;
          dispatch(getDashboardSuccess(data));

          dispatch(postJobSuccess("")); // Reset Job Posting info
          resolve(data);
        })
        .catch(error => {
          let errorMessage = "";
          errorMessage = getErrorMessage(error);
          dispatch(showSnackBar(errorMessage));
          dispatch(logEvents("ERROR", { error_string: error.message }));
          dispatch(getDashboardFailure(error));
        });
    });
  };
};

export const getDashboardLoading = () => {
  return {
    type: types.GET_DASHBOARD_LOADING
  };
};

export const getDashboardSuccess = payload => {
  return {
    type: types.GET_DASHBOARD_SUCCESS,
    payload: payload
  };
};

export const getDashboardFailure = error => {
  return {
    type: types.GET_DASHBOARD_FAILURE,
    payload: error
  };
};

export const closeJob = (dataObj, activeTab, formattedTab, callBack) => {
  const {
    jobId,
    reasonId = "",
    reasonText,
    subReasonId = [],
    closedJobDetails = {}
  } = dataObj;
  return dispatch => {
    dispatch(closeJobLoading());
    makeAjaxRequest({
      method: "POST",
      url: fetchUrl("recruiter", "job/v2/close-job"),
      data: {
        job_id: jobId,
        close_reason_id: reasonId,
        close_reason_text: reasonText ? reasonText : undefined,
        sub_reason_ids: subReasonId
      }
    })
      .then(response => {
        let data = response.data.data;
        if (
          activeTab === "active" &&
          reasonId == 1 &&
          subReasonId.length &&
          subReasonId[0] == 1
        ) {
          dispatch(showHiringCertificateDrawer(true));
          dispatch(setClosedJobDetails(closedJobDetails));
        }
        dispatch(closeJobSuccess(data));

        if (activeTab) {
          dispatch(setActiveTab(activeTab));
        }
        return true;
      })
      .then(() => {
        if (callBack) {
          callBack();
        }
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
        dispatch(closeJobFailure(error));
      });
  };
};

export const closeJobLoading = () => {
  return {
    type: types.CLOSE_JOB_LOADING
  };
};

export const closeJobSuccess = payload => {
  return {
    type: types.CLOSE_JOB_SUCCESS,
    payload: payload
  };
};

export const closeJobFailure = error => {
  return {
    type: types.CLOSE_JOB_FAILURE,
    payload: error
  };
};

export const getCloseJobMetadata = () => {
  return (dispatch, store) => {
    dispatch(getCloseJobMetadataLoading());

    const cache = CacheService.checkInCache({
      key: STORAGE_ITEMS.CLOSE_REASONS_CACHE,
      cacheName: STORAGE_ITEMS.CLOSE_REASONS_CACHE,
      storageType: STORAGE_KEYS.LOCAL_STORAGE
    });

    if (!cache) {
      makeAjaxRequest({
        method: "GET",
        url: fetchUrl("v2/metadata", "job_close_reasons"),
        auth: true
      })
        .then(response => {
          const { data } = response.data;
          const { job_close_reason } = data;
          if (job_close_reason) {
            CacheService.addToCache({
              data: {
                key: STORAGE_ITEMS.CLOSE_REASONS_CACHE,
                value: job_close_reason
              },
              cacheName: STORAGE_ITEMS.CLOSE_REASONS_CACHE,
              storageType: STORAGE_KEYS.LOCAL_STORAGE,
              ttl: 720
            });

            dispatch(getCloseJobMetadataSuccess(job_close_reason));
          }
        })
        .catch(error => {
          let errorMessage = "";
          errorMessage = getErrorMessage(error);
          dispatch(showSnackBar(errorMessage));
          dispatch(getCloseJobMetadataFailure(error));
        });
    } else {
      dispatch(getCloseJobMetadataSuccess(cache));
    }
  };
};

export const getCloseJobMetadataLoading = () => {
  return {
    type: types.GET_CLOSE_JOB_LOADING
  };
};

export const getCloseJobMetadataSuccess = payload => {
  return {
    type: types.GET_CLOSE_JOB_SUCCESS,
    payload: payload
  };
};

export const getCloseJobMetadataFailure = error => {
  return {
    type: types.GET_CLOSE_JOB_FAILURE,
    payload: error
  };
};

export const setActiveTab = activeTab => {
  return dispatch => {
    dispatch({
      type: types.SET_ACTIVE_TAB,
      activeTab
    });
  };
};

/**** Start API for still hiring *******/
//can remove this once new joblist is created
export const stillHiring = (jobId, formattedTab) => {
  return dispatch => {
    dispatch(stillHiringLoading());
    makeAjaxRequest({
      method: "POST",
      url: fetchUrl("recruiter", "job/still-hiring-nudge"),
      data: {
        job_id: jobId
      },
      auth: true
    })
      .then(response => {
        let data = response.data.data;
        dispatch(stillHiringSuccess(data));
        dispatch(showSuccessSnackBar("Thank you for your feedback!"));
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
        dispatch(stillHiringFailure(error));
      });
  };
};

export const stillHiringLoading = () => {
  return {
    type: types.STILL_HIRING_LOADING
  };
};

export const stillHiringSuccess = payload => {
  return {
    type: types.STILL_HIRING_SUCCESS,
    payload: payload
  };
};

export const stillHiringFailure = error => {
  return {
    type: types.STILL_HIRING_FAILURE,
    payload: error
  };
};

/***** End API for still hiring *****/

/**** Start API for share job *******/

export const shareJob = (jobId, page) => {
  return dispatch => {
    dispatch(shareJobLoading());
    makeAjaxRequest({
      method: "POST",
      url: fetchUrl("recruiter", "job/v2/share-job"),
      data: {
        jobId: jobId,
        page
      },
      auth: true
    })
      .then(response => {
        let data = response.data.data;
        dispatch(shareJobSuccess(data));
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
        dispatch(shareJobFailure(error));
      });
  };
};

export const shareJobLoading = () => {
  return {
    type: types.SHARE_JOB_LOADING
  };
};

export const shareJobSuccess = payload => {
  return {
    type: types.SHARE_JOB_SUCCESS,
    payload: payload
  };
};

export const shareJobFailure = error => {
  return {
    type: types.SHARE_JOB_FAILURE,
    payload: error
  };
};

export const copySuccess = () => {
  return dispatch => {
    dispatch(showSuccessSnackBar("Messages Copied!"));
  };
};

export const showHiringCertificateDrawer = payload => {
  return {
    type: types.SHOW_HIRING_CERTIFICATE_DRAWER,
    payload
  };
};

export const setClosedJobDetails = payload => {
  return {
    type: types.CLOSED_JOB_DETAILS,
    payload: payload
  };
};
/***** End API for share job *****/

export const markJobStoryRead = jobId => {
  return dispatch => {
    dispatch(markJobStoryReadLoading());
    makeAjaxRequest({
      method: "GET",
      url: fetchUrl("recruiter", "mark-job-story-read"),
      auth: true
    })
      .then(response => {
        let data = response.data.data;
        dispatch(markJobStoryReadSuccess(data));
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
        dispatch(markJobStoryReadFailure(error));
      });
  };
};

export const markJobStoryReadLoading = () => {
  return {
    type: types.MARK_JOB_STORY_READ_LOADING
  };
};

export const markJobStoryReadSuccess = payload => {
  return {
    type: types.MARK_JOB_STORY_READ_SUCCESS,
    payload: payload
  };
};

export const markJobStoryReadFailure = error => {
  return {
    type: types.MARK_JOB_STORY_READ_FAILURE,
    payload: error
  };
};
